import React, { useRef } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { miningExpertiseData } from "../Data";

const ExpertiseCards=()=>{
const prevRef = useRef(null);
  const nextRef = useRef(null);
    return(
        <>
        {/*<section className="mining-expertise">
  <div className="container">

   <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Mining, Mineral Processing & Manufacturing Expertise
        </motion.h2>

    <motion.div className="mining-expertise-cards">
      {miningExpertiseData.map((item, index) => (
        <div
          key={item.id}
          className={`mining-expertise-card ${
            index === 1 ? "active" : ""
          }`}
        >
          <div className="mining-expertise-img">
            <img src={item.img} alt={`${item.title} | Iris Impulse`} />
          </div>

          <div className="mining-expertise-content">
            <h3>{item.title}</h3>
            <p className="section-text">{item.desc}</p>
          </div>
        </div>
      ))}
    </motion.div>

  </div>
</section>*/}
 <section className="mining-cards">
  <div className="container">

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
    >
      MINING, MINERAL PROCESSING & MANUFACTURING EXPERTISE
    </motion.h2>

    <div className="mining-cards-slider">
      <div ref={prevRef} className="custom-arrow prev-arrow">
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          whileHover={{ scale: 1.1 }}
        >
          &#10094;
        </motion.span>
      </div>

      <div ref={nextRef} className="custom-arrow next-arrow">
        <motion.span
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          whileHover={{ scale: 1.1 }}
        >
          &#10095;
        </motion.span>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        loop={true}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current
        }}
        pagination={{
          clickable: true,
          el: ".mining-pagination"
        }}
        className="mining-swiper"
      >
        {miningExpertiseData.map((item) => (
          <SwiperSlide key={item.id}>

            <motion.div
              className="mining-slide"
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >

              {/* IMAGE */}
              <div className="mining-image">
                <motion.img
                  src={item.img}
                  alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                  initial={{ scale: 1.05 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 1.2 }}
                />
              </div>

              {/* CARD */}
              <motion.div
                className="mining-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.6 }}
              >
                 <div className="mining-card-inner">

    <h3>{item.title.toUpperCase()}</h3>

    <p className="section-text">
      {item.desc}
    </p>

  </div>
              </motion.div>

            </motion.div>

          </SwiperSlide>
        ))}
      </Swiper>

      {/* PAGINATION */}
      <motion.div
        className="mining-pagination"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      />

    </div>
  </div>
</section>
        </>
    )
}
export default ExpertiseCards;